import SvgEllipse from "@Components/CustomIcon/SvgEllipseOrange"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { UserProgramContext } from "@Providers/ProgramProvider"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { surveyProgressAtom, surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import { SurveyService } from "@Services/Survey.Service"
import { isCptsInstance } from "@Utils/utils"
import React, { useEffect, useState } from "react"
import { useContext } from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"
import { ProgressBar } from "react-native-paper"
import { useRecoilState, useRecoilValue } from "recoil"

export const CustomCard = (props) => {
    const { axisId, setFetchingAxisSurveys } = props
    const responses = useRecoilValue(surveyResponsesAtom)
    const [progressOfAllAxis, setProgressOfAllAxis] = useRecoilState(surveyProgressAtom)
    const [loading, setLoading] = useState(true)
    const [surveysList, setSurveysList] = useState([])
    const [surveyParentId, setSurveyParentId] = useState(0)
    const [percentageFinished, setPercentageFinished] = useState(0)
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)
    const { preselectedPatientProgram } = useContext(UserProgramContext)

    useEffect(() => {
        if (preselectedPatientProgram?.length > 0 && preselectedPatientProgram?.[0]?.surveyParentId > 0) {
            setSurveyParentId(preselectedPatientProgram?.[0]?.surveyParentId)
        }
    }, [preselectedPatientProgram])

    const fetchSurveys = () => {
        setLoading(true)
        setFetchingAxisSurveys(true)
        SurveyService.getByAxis(axisId, surveyParentId)
            .then((response) => {
                const data = response.data?.data
                if (data) {
                    const removeParentItem = data?.filter((item) => item?.hasChild === 0) ?? []
                    setSurveysList(removeParentItem)
                }
                setLoading(false)
                setFetchingAxisSurveys(false)
            })
            .catch((e) => {
                // ShowToast({ type: "error", message: message.serverError })
                console.log({ ErrofetchingSurveys: e })
                setLoading(false)
                setFetchingAxisSurveys(false)
            })
    }

    const getSurveyLength = (list) => {
        let distinctList = new Set()
        list.map((item) => {
            distinctList.add(item.id)
            if (item?.children?.length > 0) {
                item?.children?.map((itm) => distinctList.add(itm.id))
            }
        })
        return distinctList
    }

    useEffect(() => {
        if (!isCptsInstance()) {
            fetchSurveys()
        } else {
            if (surveyParentId > 0) {
                fetchSurveys()
            }
        }
    }, [surveyParentId])

    useEffect(() => {
        let totalAnswered = 0
        if (currentEducationalDiagnosis?.id > 0 && !loading) {
            setPercentageFinished(100)
        } else {
            if (surveysList?.length) {
                const allSurveyIds = getSurveyLength(surveysList)
                allSurveyIds.forEach((id) => {
                    if (responses[id]) {
                        totalAnswered += 1
                    }
                })
                let percent = totalAnswered === 0 ? 0 : (totalAnswered * 100) / allSurveyIds.size
                setPercentageFinished(percent)
                setProgressOfAllAxis((prev) => [
                    ...prev.filter((itm) => itm.axisId !== axisId),
                    { axisId: axisId, percent: percent }
                ])
            }
        }
    }, [surveysList, responses, currentEducationalDiagnosis, loading])

    const prevAxis = progressOfAllAxis?.find((axis) => axis.axisId == axisId - 1)

    const disabled = loading ? true : currentEducationalDiagnosis?.id > 0 ? false : prevAxis?.percent < 100 ?? true

    const axisTextColor = disabled ? baseColors.grey : "white"

    return (
        <TouchableOpacity disabled={disabled} activeOpacity={0.7} onPress={props.onPress}>
            <View
                style={{
                    borderRadius: 10,
                    overflow: "hidden",
                    height: 101,
                    width: "100%",
                    marginVertical: 8,
                    backgroundColor: props.backgroundColor
                }}
            >
                <BreeSerifText style={{ marginHorizontal: 15, marginTop: 15 }} fontSize={20} color={axisTextColor}>
                    {props.title}
                </BreeSerifText>

                <Spacer height={10} />

                <OpenSansText fontSize={14} style={{ marginHorizontal: 15 }} color={axisTextColor}>
                    {loading ? "chargement en cours ..." : ` Complété à ${percentageFinished.toFixed(0)} %`}
                </OpenSansText>

                <View style={{ position: "absolute", alignSelf: "flex-end" }}>
                    <SvgEllipse height={101} width={100} fill={props.ellipseColor}></SvgEllipse>
                    {props.svgIcon}
                </View>

                <View style={{ paddingHorizontal: 15, paddingTop: 5, width: "70%" }}>
                    <ProgressBar
                        style={{ height: 5, borderRadius: 1, backgroundColor: axisTextColor }}
                        theme={{
                            roundness: 0,
                            colors: {
                                primary:
                                    props.backgroundColor == baseColors.green.primary
                                        ? baseColors.orange.primary
                                        : baseColors.green.dark
                            }
                        }}
                        backgroundColor={"white"}
                        progress={percentageFinished / 100}
                    />
                </View>
            </View>
        </TouchableOpacity>
    )
}

const style = StyleSheet.create({
    container: {
        borderRadius: 10,
        overflow: "hidden",
        height: 101,
        width: "100%",
        marginVertical: 8
    }
})
